import React, { useState } from "react"
import { Box, Checkbox, Grid, IconButton, Typography } from "@mui/material"
import CustomOrderOptionCheckbox from "../CustomOrderOptionCheckbox"
import ColorBox from "../ColorBox"
import { ExpandLess, ExpandMore } from "@mui/icons-material"
import Collapse from "@mui/material/Collapse"
import { getCurrencyStringFromNumber } from "../../../Util/Util"

const Extras = ({
  updateOptions,
  selectedGlassOnFinOption,
  setSelectedGlassOnFinOption,
  glassOnFinsOption,
  orderData,
  selectedGlossFinishOption,
  setSelectedGlossFinishOption,
  glossFinishOption,
  isStaff,
  selectedPinLineColorOption,
  setSelectedPinLineColorOption,
  pinLineColorOptions,
  selectedAbstractColorOption,
  setSelectedAbstractColorOption,
  abstractColorOption,
}) => {
  const [open, setOpen] = useState(true)
  const disabled = orderData?.locked && !isStaff

  const pinLinePrice = pinLineColorOptions?.[0]?.price
  let pinLineTitle = "Pin Line"
  if (pinLinePrice > 0) pinLineTitle += ` ${getCurrencyStringFromNumber(pinLinePrice)}`

  let abstractTitle = abstractColorOption?.type_display || "Abstract Color"
  if (abstractColorOption?.price > 0) abstractTitle += ` ${getCurrencyStringFromNumber(abstractColorOption.price)}`

  return (
    <React.Fragment>
      <Box display="flex" alignItems="center" justifyContent="center" sx={{ position: "relative" }}>
        <Typography variant="h5">Extras</Typography>
        <IconButton onClick={() => setOpen(!open)} sx={{ position: "absolute", right: 0 }}>
          {open ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>
      <Collapse in={open}>
        <CustomOrderOptionCheckbox
          isStaff={isStaff}
          orderData={orderData}
          selectedOption={selectedGlassOnFinOption}
          setSelectedOption={setSelectedGlassOnFinOption}
          option={glassOnFinsOption}
          updateOptions={updateOptions}
        />
        <CustomOrderOptionCheckbox
          isStaff={isStaff}
          orderData={orderData}
          selectedOption={selectedGlossFinishOption}
          setSelectedOption={setSelectedGlossFinishOption}
          option={glossFinishOption}
          updateOptions={updateOptions}
        />

        {/* Pin Line */}
        <Box pb={3}>
          <Grid container justifyContent="center" alignItems="center" sx={{ position: "relative" }}>
            <Box my={3} display="flex" alignItems="center">
              <Typography style={{ fontFamily: "Josefin Sans", fontWeight: "bold" }}>
                {pinLineTitle}
              </Typography>
            </Box>
            <Checkbox
              checked={!!selectedPinLineColorOption}
              disabled={disabled}
              sx={{ position: "absolute", right: 0, color: "rgba(255,255,255,0.5)", "&.Mui-checked": { color: "#4fc3f7" } }}
              onChange={(e) => {
                if (e.target.checked && pinLineColorOptions?.length) {
                  const first = pinLineColorOptions[0]
                  setSelectedPinLineColorOption(first)
                  updateOptions([first], [])
                } else {
                  updateOptions([], [selectedPinLineColorOption])
                  setSelectedPinLineColorOption(null)
                }
              }}
            />
          </Grid>
          <Collapse in={!!selectedPinLineColorOption}>
            <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 0.8, pb: 1 }}>
              {pinLineColorOptions?.map((cO) => (
                <ColorBox
                  key={cO.id}
                  colorOption={cO}
                  clickable={!disabled}
                  selected={selectedPinLineColorOption?.value === cO?.value}
                  handleColorSelect={(c) => {
                    setSelectedPinLineColorOption(c)
                    updateOptions([c])
                  }}
                />
              ))}
            </Box>
          </Collapse>
          <Typography variant="caption" style={{ fontFamily: "Josefin Sans", textAlign: "center", display: "block" }}>
            Choose the color for a pin line on the rails of the board
          </Typography>
        </Box>

        {/* Abstract Color */}
        <CustomOrderOptionCheckbox
          isStaff={isStaff}
          orderData={orderData}
          selectedOption={selectedAbstractColorOption}
          setSelectedOption={setSelectedAbstractColorOption}
          option={abstractColorOption}
          updateOptions={updateOptions}
        />
      </Collapse>
    </React.Fragment>
  )
}

export default Extras
